import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд ABC
const GeneralPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="Загальні показники компанії"
      iframeTitle="Звіт Загальні показники компанії"
      endpointUrl="/reports/general/embed-url"
    />
  );
};

export default GeneralPage;
